import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { borderRadius, palette, spaces } from '../../../../assets/styles/themes/tokens';
import { EMAIL_MAX_LENGTH } from '../checkout.constants';
import type { EmailCheckState } from '../checkout.types';

const EmailInputSection: React.FC<{
  email: string;
  onEmailChange: (value: string) => void;
  state: EmailCheckState;
}> = ({ email, onEmailChange, state }) => {
  const { t } = useTranslation();

  const errorMessage =
    state.kind === 'invalid-format'
      ? t('Please enter a valid email address')
      : state.kind === 'has-active-sub'
        ? t('An account with this email is already active — please sign in')
        : state.kind === 'verify-failed'
          ? t('Could not verify this email — please try again')
          : '';

  const isError =
    state.kind === 'invalid-format' ||
    state.kind === 'has-active-sub' ||
    state.kind === 'verify-failed';

  return (
    <Box
      data-testid='stripe-checkout-email-section'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: spaces.xs,
        marginBottom: spaces.lg,
      }}
    >
      <Typography variant='body1' color={palette.text.primary}>
        {t('E-Mail-Address')}
      </Typography>
      <TextField
        variant='outlined'
        placeholder={t('eg max.mustermann@beispiel.de')}
        type='email'
        size='small'
        value={email}
        onChange={(event) => onEmailChange(event.target.value)}
        fullWidth
        autoComplete='email'
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: borderRadius.xs,
          },
        }}
        inputProps={{ maxLength: EMAIL_MAX_LENGTH, 'data-testid': 'stripe-checkout-email-input' }}
        error={isError}
        helperText={errorMessage}
      />
    </Box>
  );
};

export default EmailInputSection;
